import { useQuery } from '@tanstack/react-query';

import { ILessons } from 'modules/courses';
import { $apiV2 } from 'modules/global';

import { lessonConst } from '..';

export const getLessons = (slug?: string) => async () => {
  const { data } = await $apiV2.get(`/teacher-course/course-name/${slug}/lessons`);

  return { lessons: data?.data };
};

export const useLessons = (slug?: string) => {
  const { data, ...args } = useQuery<{ lessons: ILessons }>({
    queryKey: [lessonConst.queryKeys.LESSONS_LIST, slug],
    queryFn: getLessons(slug),
    enabled: !!slug,
  });

  return { ...data, ...args };
};
